// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__LfJMr","Header__pic":"Header_Header__pic__XxOMK","Header__content":"Header_Header__content__SFbSb"};